export default {

  /**
   * 轮播图下方的icon
   */
  bigIcon: [
    {key: '1', url: '', value: '网上竞价'},
    {key: '2', url: '', value: '竞价展场'},
    {key: '3', url: '', value: '智能采购'},
    {key: '4', url: '', value: '预算采购管理'}
  ],

  /**
   * 采购类型
   */
  procurementTypeList: [
    {key: 'A', value: '通用设备'},
    {key: 'D', value: '科研仪器'},
    {key: 'E', value: '实验试剂'},
    {key: 'F', value: '耗材'},
    {key: 'B', value: '工程'},
    {key: 'C', value: '服务'},
    {key: 'G', value: '租息'},
    // {key: 'H', value: '非竞价类'},
    {key: 'M', value: '药品'},
    {key: 'I', value: '多品牌'},
    {key: 'J', value: '个人自购'},
    {key: 'Z', value: '大额竞价'},
    {key: 'N', value: '议价'},
    {key: 'O', value: '联合采购'},
    {key: 'P', value: '邀请竞价'}
  ],
  // 竞价结果用
  procurementTypeList2: [
    {key: 'A', value: '通用设备'},
    {key: 'D', value: '科研仪器'},
    {key: 'E', value: '实验试剂'},
    {key: 'F', value: '耗材'},
    {key: 'B', value: '工程'},
    {key: 'C', value: '服务'},
    {key: 'G', value: '租息'},
    {key: 'H', value: '非竞价类'},
    {key: 'M', value: '药品'},
    {key: 'I', value: '多品牌'},
    {key: 'P', value: '邀请竞价'},
    {key: 'N', value: '议价'},
    {key: 'O', value: '联合采购'}
    // {key: 'J', value: '个人自购'},
    // {key: 'K', value: '竞价展场'},
  ],

  orderTypeList: [
    {key: '1', value: '普通竞价类'},
    {key: '2', value: '非竞价类'},
    {key: '3', value: '多品牌'},
    {key: '4', value: '参照自选'},
    {key: '5', value: '个人自购'},
    {key: '6', value: '比价采购'},
    {key: '7', value: '展场直采'},
    {key: '8', value: '试剂竞价类'},
    {key: '9', value: '耗材竞价类'},
    {key: '10', value: '小工程竞价'},
    {key: '11', value: '服务竞价'},
    {key: '12', value: '租售'},
  ],
  orderType:{1:'单一品牌',2:'单一品牌',3:'多品牌',4:'单一品牌',5:'竞价展场',6:'竞价展场',7:'竞价展场',8:'单一品牌',9:'单一品牌', 10:'单一品牌',11:'单一品牌',12:'单一品牌'},
  /**
   * 加盟单位类型
   */
  sourceTypeList: [
    {key: 'C', value: '学校'},
    {key: 'H', value: '医疗机构'},
    {key: 'S', value: '科研机构'},
    {key: 'O', value: '事业单位'},
    {key: 'E', value: '企业'}
  ],

  /**
   * 所在地区
   */
  areaScopeList: [
    {key: '01', value: '华南'},
    {key: '02', value: '华北'},
    {key: '03', value: '华东'},
    {key: '04', value: '华中'},
    {key: '05', value: '西北'},
    {key: '06', value: '东北'},
    {key: '07', value: '西南'}
  ],

  /**
   * 招标信息 - 招标类型
   */
  infoTypeList: [
    {key: '1', value: '智采公告'},
    {key: '2', value: '智采结果公示'}
  ],

  /**
   * 招标信息 - 项目类型
   */
  projectTypeList: [
    {key: '1', value: '工程招标'},
    {key: '2', value: '货物招标'},
    {key: '3', value: '服务招标'}
  ],

  /**
   * 新闻资讯 - 新闻类别
   */
  newsType: [
    {key: '1', value: '竞采要闻'},
    {key: '2', value: '高校新闻'},
    {key: '0', value: '智采信息'},
    {key: '3', value: '业界声音'},
    {key: '4', value: '政采论坛'},
    {key: '5', value: '政策法规'},
    {key: '6', value: '行业资讯'},

    {key: '203', value: '研究探索'}
  ],

  /**
   * 帮助中心 - 供应商帮助
   */
  supplierHelpList: [
    {key: '101', value: '供应商注册'},
    {key: '102', value: '供应商登录'},
    {key: '103', value: '网上报价'},
    {key: '104', value: '发货管理'},
    {key: '105', value: '争议处理'}
  ],

  /**
   * 帮助中心 - 高校帮助
   */
  collegeHelpList: [
    {key: '201', value: '法律法规'},
    {key: '202', value: '动态发布'},
    {key: '203', value: '研究探索'},
    {key: '204', value: '申购管理'},
    {key: '205', value: '中标管理'},
    {key: '206', value: '收货管理'},
    {key: '207', value: '供应商审核'},
    {key: '208', value: '供应商评价'},
    {key: '209', value: '登录与权限'},
  ],
  cpHelpList: [
    {key: '401', value: '产品介绍'},
  ],

  /**
   * 采购需求 - 发票类型
   */
  invoiceTypeList: [
    {key: '1', value: '增值税普通发票'},
    {key: '2', value: '增值税专用发票'}
  ],

  /**
   * 采购需求 - 报价要求
   */
  isTaxList: [
    {key: 'Y', value: '含税'},
    {key: 'N', value: '免税'},
    {key: 'A', value: '国产含税'},
    {key: 'B', value: '进口免税'},
    {key: 'C', value: '进口含税'},
    {key: 'D', value: '不限'}
  ],

  /**
   * 优质供应商 - 供应商优质级别
   */
  companyLevelList: [
    {key: '1', value: '1级'},
    {key: '2', value: '2级'},
    {key: '3', value: '3级'}
  ],

  classifyTypeList: [
    {key: '1', value: '货物'},
    {key: '2', value: '工程'},
    {key: '3', value: '服务'}
  ],
  noticeTypeList: [
    {key: '1', value: '智采公告'},
    {key: '2', value: '更正公告'},
    {key: '11', value: '补充公告'},
    {key: '6', value: '结果公示'},
    {key: '7', value: '结果公告'},
    {key: '4', value: '终止公告'},
    {key: '5', value: '流标公告'},
    {key: '8', value: '合同公示'},
    {key: '9', value: '废标公告'},
    {key: '10', value: '采购意向'}
  ],
  tenderTypeList:[
    {key: '3', value: '智能采购'},
    {key: '2', value: '智能采购'},
    {key: '1', value: '传统招项目'}
  ],
  NewAreaScopeList: [
    {key: '01', value: '华南'},
    {key: '02', value: '华北'},
    {key: '03', value: '华东'},
    {key: '04', value: '华中'},
    {key: '05', value: '西北'},
    {key: '06', value: '东北'},
    {key: '07', value: '西南'},
    {key: '08', value: '东南'},
  ],


}



// WEBPACK FOOTER //
// ./src/constants/constants.js